import { resilientQueryOptions } from 'constants/'
import { UseQueryOptions, useQuery } from 'react-query'
import { logFactory } from 'utils'
import { useDocumentService } from '../services'

const hookName = 'useDocuments'
const log = logFactory(hookName)

const useDocuments = (
  query: Parameters<ReturnType<typeof useDocumentService>['getDocuments']>[0],
  options: UseQueryOptions = {
    enabled: true,
  }
) => {
  const { getDocuments } = useDocumentService()

  const fetchDocuments = async () => {
    const params = { ...query }

    log(`🗃️ Fetching documents...`, params)

    const { documents } = await getDocuments(params)

    log(`🗃️ Found ${documents.length} documents`, documents)

    return documents
  }

  return useQuery([hookName, query], fetchDocuments, {
    ...resilientQueryOptions,
    enabled: options.enabled ?? true,
    refetchOnMount: false,
  })
}

export { useDocuments }
